query SupplierAvailableTags($id: UUID!) {
  supplierAvailableTags(entityId: $id) {
    nodes {
      id
      name
      badgeName
      badgeColor
    }
  }
}
